/**
 * Densité visuelle équivalente ~ zoom navigateur 80 %.
 * Utilisable dans le thème (`create-*`) et dans les composants pour harmoniser les `px` codés en dur.
 */
export const DENSITY = 0.9 as const

/** Arrondit une valeur en px selon la densité. */
export function densityPx(value: number): number {
  return Math.round(value * DENSITY)
}

/** Valeur en px pour style inline / template. */
export function densityPxStr(value: number): `${number}px` {
  return `${densityPx(value)}px`
}

/** Taille en rem (référence design × DENSITY). */
export function densityRem(designRem: number): string {
  return `${designRem * DENSITY}rem`
}
